import {forwardRef} from 'react';

import {ClickAwayListener, Paper, Popper} from '@mui/material';
import {bool, element, func, node, object, oneOf, oneOfType, shape, string} from 'prop-types';

import MorePopperArrow from '../MorePopperArrow/MorePopperArrow';

const PopperComponent = forwardRef(({anchorEl, placement = 'right', isOpen, onClose, paperStyle, hasArrow = true, arrowStyle, children}, ref) => {
  return (
    <Popper ref={ref} sx={{zIndex: 9999}} placement={placement} anchorEl={anchorEl} open={isOpen}>
      {hasArrow ? <MorePopperArrow style={arrowStyle} /> : null}

      <ClickAwayListener onClickAway={onClose}>
        <Paper
          sx={{
            background: '#F6F6F6',
            boxShadow: '1px 1px 4px rgba(0, 0, 0, 0.4)',
            borderRadius: 3,
            p: 1,
            ...paperStyle
          }}
        >
          {children}
        </Paper>
      </ClickAwayListener>
    </Popper>
  );
});

PopperComponent.propTypes = {
  anchorEl: oneOfType([object, element, node, oneOf([null])]),
  arrowStyle: shape({}),
  paperStyle: shape({}).isRequired,
  isOpen: bool.isRequired,
  onClose: func.isRequired,
  hasArrow: bool,
  placement: string,
  children: oneOfType([node, func]).isRequired
};

export default PopperComponent;
